import { useAuthContext } from 'state/auth';
import { useFlag } from 'utils/launchdarkly';

const useIsSignUpAfterCart = (): boolean => {
  const { isAuthenticated } = useAuthContext();
  const enableSignupAfterCart = useFlag('enable-move-signup-after-cart');
  return !isAuthenticated && enableSignupAfterCart;
};

export default useIsSignUpAfterCart;
